import { setupLibBackend } from "@/toremove/setup";
import { mapActions, mapGetters } from "vuex";
import { defineAsyncComponent } from 'vue';

var baseLib = setupLibBackend("user", "Userv2");
var emits = [];
function data(){};
var components = {
    NotificationsDropDown: defineAsyncComponent(() => import("@/octolo/user/utils/NotificationsDropDown.vue")),
};
var watch = {};
var props = {};
var computed = {
    //...mapState("Userv2", ["profile", "keep_url",
    //    //to remove
    //    "contextmenu", "tooltip",
    //]),
    //...mapGetters("Userv2", ["isAuthenticated", "profile", "cssTheme"]),
    ...mapGetters("Userv2", ["cssTheme",]),
    userTheme(){ return "light"; },
};
var methods = {
    ...mapActions("Userv2", ["userLogout", "userKeepUrl",
        //to remove
        "openContextMenu", "closeContextMenu",
        "openTooltip", "closeTooltip",
    ]),
    async prepareUser(){
        if(this.isAuthenticated) {
            await this.userSetCurrentState();
        }else{
            this.userKeepUrl(this.$route.fullPath);
            this.userGoOnLogin();
        }
    },
    userUrlLogin(){ return {name: "user-login"}; },
    userGoOnLogin(){ this.$router.push(this.userUrlLogin()); },

};

import autoService from "@/autolib/service.js";
export default autoService("user", "Userv2", {
    emits: baseLib.emits.concat(emits),
    data(){ return Object.assign(baseLib.data(), data()); },
    components: components,
    watch: Object.assign(baseLib.watch, watch),
    props: Object.assign(baseLib.props, props),
    computed: Object.assign(baseLib.computed, computed),
    methods: Object.assign(baseLib.methods, methods),
});
